export default "__VITE_PUBLIC_ASSET__b8ba5c05__"